import { render } from "./Tongji.vue?vue&type=template&id=7da73b2a&scoped=true"
import script from "./Tongji.vue?vue&type=script&lang=js"
export * from "./Tongji.vue?vue&type=script&lang=js"

import "./Tongji.vue?vue&type=style&index=0&id=7da73b2a&scoped=true&lang=css"

import exportComponent from "/Users/windy/work/vue/project/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7da73b2a"]])

export default __exports__